import {
  Button, Card, Radios, WarningCallout,
} from 'nhsuk-react-components';
import Back from 'components/Back';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { ITeamLevelParams } from 'utils/parameterUtils.ts';
import useFetchCampaignTemplatesForTeam from 'queries/fetch/fetchCampaignTemplatesForTeam.ts';
import ProgressIndicator from 'components/ProgressIndicator';
import useFetchTeamDetails from 'queries/fetch/fetchTeamDetails.ts';

function SelectCampaignTemplatePage() {
  const navigate = useNavigate();
  const { teamId } = useParams() as ITeamLevelParams;
  const teamDetails = useFetchTeamDetails({ teamId });
  const templatesForTeam = useFetchCampaignTemplatesForTeam({ teamId });
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!selectedTemplate) {
      setError('Choose a template to continue');
      return;
    }

    navigate(`/${teamId}/campaign/new/key-details?template=${selectedTemplate}`);
  };

  if (!templatesForTeam.data) {
    return <ProgressIndicator />;
  }

  return (
    <>
      <div className="nhsuk-u-margin-bottom-6">
        <Back />
      </div>

      <Card>
        <main
          id="maincontent"
          className="nhsuk-heading-l nhsuk-u-margin-top-0 nhsuk-u-margin-bottom-3"
        >
          Template selection
        </main>
      </Card>

      {
        templatesForTeam.data.templates.length === 0 && (
        <WarningCallout>
          <WarningCallout.Heading>
            Selected team has no templates
          </WarningCallout.Heading>
          <p>
            {teamDetails.data?.team.TEAM_NAME ?? teamId}
            {' '}
            has no templates assigned to it.
          </p>
          <p>
            You can go back to create a campaign without using a template, or
            {' '}
            <a href="mailto:england.invitationservicesupport@nhs.net">contact the SPI team</a>
            {' '}
            if you think this team should have templates available to it.
          </p>
        </WarningCallout>
        )
      }

      {
        templatesForTeam.data.templates.length > 0 && (
        <>
          <Card>
            <Radios
              error={error}
              hint="If you would like to request more templates contact the SPI team."
              legend="Available templates"
              legendProps={{
                size: 'm',
              }}
              small
              onChange={(e) => {
                setError('');
                setSelectedTemplate((e.target as HTMLInputElement).value);
              }}
            >
              {templatesForTeam.data.templates.map((template) => (
                <Radios.Item value={template.id} key={template.id}>
                  {template.name}
                </Radios.Item>
              ))}
            </Radios>
          </Card>

          <Button onClick={handleSubmit}>
            Continue
          </Button>
        </>
        )
      }
    </>
  );
}

export default SelectCampaignTemplatePage;
